import React, { Fragment, FunctionComponent, useContext, useState } from 'react';
import { Text } from '../../../shared/Text';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { formItems, getPostData } from '../formItems';
import { FormContext } from '../../../../store/refinance/RefinanceContext';
import { API } from '../../../../services';
import { RefinanceResponse } from '../../../../models/RefinanceReponse';
import { MortgagePartInterest } from '../../MortgagePartInterest';
import { scrollToTopCalculator } from '../../../../utils/general';

export const Step4: FunctionComponent<{ id: number }> = ({id}) => {
	const {
		register,
		handleSubmit,
		setValue,
		formState: {errors, isValid},
	} = useForm({mode: 'onChange'});

	const [completedText, setCompletedText] = useState('');
	const {updateForm, updateData, form, setIsLoading} = useContext(FormContext);

	const onSubmit = (data: any) => {

		updateForm(data);
		setCompletedText('rente gekozen');
		setIsLoading(true);

		const formData = {
			...form,
			...data,
		};


		//API.post<RefinanceResponse>('calculator/calculatemortgagetransfer', getPostData(formData))
		API.post<RefinanceResponse>('calculator/calculatemortgagetransfer', getPostData(formData))
			.then((res) => {
				updateData(res);
				setIsLoading(false);
				scrollToTopCalculator();
			})
			.catch((error) => {
				//console.log(error);
				setIsLoading(false);
			});
		// format form data to match API
		// do api call etcetc
	};


	const getValuesFormMortgagePart = (part: number) => {
		if (typeof form[formItems.step2.mortgageParts] !== 'undefined') {
			return form[formItems.step2.mortgageParts][part]
		}
	}

	return (
		<Fragment>
			<StepperHeader title="Nieuwe hypotheek" id={id} completedText={completedText}/>
			<StepperContent>
				<Text as="h3">Je kunt hieronder een keuze maken voor een nieuwe rente en rentevaste periode</Text>
				<form onSubmit={handleSubmit(onSubmit)}>
					{[...Array(form[formItems.step1.countMortgageParts])].map((x, i) =>
						<MortgagePartInterest
							register={register}
							errors={errors}
							part={i}
							setValue={setValue}
							values={getValuesFormMortgagePart(i)}
							key={i}></MortgagePartInterest>
					)}
					<StepperSubmit variant={"primary"} id={id} isValidated={isValid}/>
				</form>
			</StepperContent>
		</Fragment>
	);
};
